// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1Aoc8","title":"BackImages_title__2LaNf","images":"BackImages_images__1Pj0J"};